var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "m20.423 14.912-.036.044.05.027a4.015 4.015 0 0 1-1.937 7.533h-6.25a.89.89 0 0 1-.89-.891V9.75a.89.89 0 0 1 .89-.89h5.313a3.703 3.703 0 0 1 2.86 6.052Zm-7.235-4.271h-.047v3.843H17.563a1.922 1.922 0 0 0 0-3.843h-4.375Zm-.047 10.046v.047H18.5a2.234 2.234 0 1 0 0-4.468h-5.359v4.422Z"
  })));
};
export default SvgBold;